import React from 'react';

enum DefaultColorsType {
  gray = '#F7F9FC',
  blue = '#2371A5',
}

interface DropzoneAreaProps {
  borderColor?: string;
  fillColor?: string;
  className?: string;
}

const DropzoneWidgetArea = ({ borderColor, fillColor, className }: DropzoneAreaProps) => {
  return (
    <div className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="96" viewBox="0 0 675 96" fill="none">
        <rect
          x="0.5"
          y="0.5"
          width="674"
          height="95"
          rx="3.5"
          strokeDasharray="8 10"
          fill={fillColor || DefaultColorsType.gray}
          stroke={borderColor || DefaultColorsType.blue}
          strokeMiterlimit="2.3662"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default DropzoneWidgetArea;
